import axios from 'axios';
import { ROMESkill, UserSkill } from '@addviseo/shared/types';

export const searchRomeSkills = (query: string) => {
  return axios
    .get<ROMESkill[]>('/api/skill/search-rome', {
      params: { q: query },
    })
    .then((response) => response.data);
};

export const getUserSkills = () => {
  return axios.get<UserSkill[]>('/api/skill').then((response) => response.data);
};

export const createUserSkill = (skillLabel: string) => {
  return axios.post<UserSkill>('/api/skill', { skillLabel }).then((response) => response.data);
};

export const deleteUserSkill = (id: number) => {
  return axios.delete(`/api/skill/${id}`);
};

export default {
  searchRomeSkills,
  getUserSkills,
  createUserSkill,
  deleteUserSkill,
};
